import React from 'react';
import AttributesInterface from 'interfaces/attributes.interface';

import './widget-attributes-table.scss';

interface WidgetAttributesTableProps {
    attributes: AttributesInterface[];
    rowsNumber: number;
}

const WidgetAttributesTable: React.FC<WidgetAttributesTableProps> = ({ attributes, rowsNumber }) => {
    return (
        <div className="attributes-table">
            {attributes.slice(0, rowsNumber).map((row, idx) => (
                <div className="attributes-table__row" key={String(idx)}>
                    {row.label}:
                    <span className="attributes-table__row__value">
                        {row.value}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default WidgetAttributesTable;
